module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/091-slovakia-5eb25fcb0e9e83e4e3a2f95aae6ef223.svg";